import { PageResponseVm } from 'api/core/page-response.vm';
import { LocationVm } from './location.vm';
import { IsString, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';

export class GetLocationsVm extends PageResponseVm<LocationVm, string> {
  @IsString()
  nextOffset: string | null;

  @ValidateNested({ each: true })
  @Type(() => LocationVm)
  objects: LocationVm[];
}
